module.exports = __webpack_public_path__ + "img/domains.80389e0b.svg";